const cardData = [
    {
        title: "Documentation",
        description: "You can explore the features that we provide with fun and have their own functions each feature.",
        link: "https://codecanel.com/docs/wp-before-after-image-slider/",
        linkLabel: "Documentation",
    },
    {
        title: "Support",
        description:
            "Reach our dedicated support team for technical assistance, troubleshooting, and plugin-related questions.",
        link: "https://codecanel.com/contact/",
        linkLabel: "Team Support",
    },
    {
        title: "Rate Our Plugin",
        description:
            "Love using Before After Image Slider? Share your experience and help others by rating our plugin on WordPress.org.",
        link: "https://wordpress.org/support/plugin/wp-before-after-image-slider/reviews/",
        linkLabel: "Rate us",
    },
];

const InfoCards = () => {
    return (
        <section className="coca__info-cards">
            <div className="container">
                <div className="cards-wrapper">
                    {cardData.map((card, index) => (
                        <div className="info-card" key={index}>
                            <div>
                                <h3>{card.title}</h3>
                                <p>{card.description}</p>
                            </div>
                            <a href={card.link} target="_blank" rel="noopener noreferrer">
                                {card.linkLabel} <span>↗</span>
                            </a>
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default InfoCards;
